enum HealthInsuranceEligibilityStatus {
    Unknown,
    Covered,
    NotCovered,
    MissingInformation,
    Pending
}

export { HealthInsuranceEligibilityStatus };
